import React from "react"
import { deleteUser } from "@/api/usuario"

export function UserPopUpWindow ({setVisibility,name,id}:{setVisibility: React.Dispatch<React.SetStateAction<boolean>>, name:string, id :string})
{
    const userDeleteManager = async () => 
    {
        await deleteUser(id)
        setVisibility(false)
        window.location.reload()
    }

    return(
        <div 
            id = "PopUpUsers"
            className="flex flex-col bg-white rounded border border-black p-4 fixed top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 z-50 max-w-full sm:max-w-lg w-[90%]">
            <h3 className = "mt-2 mb-2 text-xl font-bold">¿Quieres eliminar el siguiente usuario?</h3>
            <p className="mt-2 mb-2">
                <b>Usuario : {name}</b>
            </p>
            <div id = "button-users-container"  className="flex justify-center">
                 <button className = "rounded bg-red p-2 mb-5 text-white font-bold w-[200px] mt-4 mr-2" onClick={() => setVisibility(false)}>
                    Cancelar
                </button>
                <button className = "rounded bg-green p-2 mb-5 text-white font-bold w-[200px] mt-4 ml-2" onClick={userDeleteManager}>
                    Confirmar
                </button>
            </div>
            
        </div>
    )
}